import * as RightArrow from './RightArrow.svg';
import * as LeftArrow from './LeftArrow.png';
import * as LeftArrowSmall from './LeftArrowSmall.svg';
import * as LeftArrowBig from './LeftArrowBig.svg';
import * as ArrowTop from './Arrowtop.svg';
import * as demoImage1 from './demoImage1.png';
import * as demoImage2 from './demoImage2.png';
import * as demoImage1Name from './demoImage1Name.svg';
import * as bank from './Bank.svg';
import * as cart from './Cart.svg';
import * as contact from './Contact.svg';
import * as rightArrowHead from './rightArrowHead.png';

export * as BankpayLogo from './BANKPAY.svg';
export * as MenuLogo from './menu.svg';

export const Images = {
  RightArrow: RightArrow.default,
  LeftArrow: LeftArrow.default,
  LeftArrowSmall: LeftArrowSmall.default,
  LeftArrowBig: LeftArrowBig.default,
  ArrowTop: ArrowTop.default,
  demoImage1: demoImage1.default,
  demoImage2: demoImage2.default,
  demoImage1Name: demoImage1Name.default,
  bank: bank.default,
  cart: cart.default,
  contact: contact.default,
  rightArrowHead: rightArrowHead.default,
  dropDownLogo: require('./dropdown.png').default, // eslint-disable-line global-require
  downArrow: require('./down-arrow.png').default,
  noCredit: require('./no-credit.png').default,
  sneakerOrderCard: require('./sneaker.png').default,
  downArrowWhite: require('./down_arrow_white.png').default,
  shopActive: require('./shop-active.png').default,
  shopInActive: require('./shop-inactive.png').default,
  creditsActive: require('./credits-active.png').default,
  creditsInActive: require('./credits-inactive.png').default,
  AccountActive: require('./account-active.png').default,
  AccountInActive: require('./account-inactive.png').default,
  profAlt: require('./prof_alt.png').default,
  login:require('./images/login-bg.png'),
  product:require('./images/prod_1.png').default
};
